function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 2.41876e-07C21.0546 -0.000687475 16.2201 1.46516 12.1078 4.21216C7.99558 6.95915 4.79028 10.8639 2.8973 15.4327C1.00431 20.0014 0.508662 25.0289 1.47303 29.8793C2.43741 34.7297 4.81848 39.1852 8.31514 42.6824C11.8118 46.1795 16.267 48.5612 21.1173 49.5263C25.9676 50.4913 30.9951 49.9964 35.5641 48.104C40.1331 46.2117 44.0383 43.0069 46.7859 38.895C49.5335 34.7831 51 29.9488 51 25.0035C51.0004 21.7201 50.3541 18.4689 49.098 15.4353C47.8418 12.4018 46.0004 9.64539 43.6789 7.32356C41.3574 5.00173 38.6012 3.15993 35.5679 1.90334C32.5345 0.646759 29.2833 2.1012e-07 26 2.41876e-07V2.41876e-07Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 33.9291C27.7661 33.9291 29.4926 33.4053 30.9611 32.424C32.4295 31.4427 33.574 30.048 34.2497 28.4162C34.9254 26.7844 35.102 24.9889 34.7572 23.2567C34.4124 21.5246 33.5617 19.9336 32.3126 18.685C31.0635 17.4363 29.4721 16.5862 27.7398 16.2421C26.0075 15.8979 24.2121 16.0753 22.5806 16.7516C20.949 17.428 19.5548 18.573 18.574 20.0418C17.5933 21.5106 17.0702 23.2373 17.0709 25.0035C17.0728 27.3707 18.0142 29.6404 19.6884 31.314C21.3626 32.9876 23.6327 33.9281 26 33.9291V33.9291ZM19.2371 25.0035C19.2371 23.6659 19.6337 22.3584 20.3769 21.2462C21.12 20.1341 22.1762 19.2673 23.4119 18.7554C24.6477 18.2435 26.0075 18.1096 27.3193 18.3706C28.6312 18.6315 29.8362 19.2756 30.782 20.2214C31.7278 21.1672 32.3719 22.3722 32.6329 23.6841C32.8938 24.996 32.7599 26.3558 32.248 27.5915C31.7362 28.8273 30.8694 29.8835 29.7572 30.6266C28.6451 31.3697 27.3375 31.7663 26 31.7663C24.2069 31.7645 22.4878 31.0514 21.2199 29.7835C19.9521 28.5156 19.239 26.7965 19.2371 25.0035V25.0035Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.9047 39.8296H17.0953C15.4885 39.8278 13.948 39.1887 12.8119 38.0525C11.6757 36.9164 11.0366 35.3759 11.0348 33.7691V16.2344C11.0366 14.6276 11.6757 13.0871 12.8119 11.951C13.948 10.8148 15.4885 10.1757 17.0953 10.1739H34.9047C36.5115 10.1757 38.0519 10.8148 39.1881 11.951C40.3243 13.0871 40.9634 14.6276 40.9652 16.2344V33.7691C40.9634 35.3759 40.3243 36.9164 39.1881 38.0525C38.0519 39.1887 36.5115 39.8278 34.9047 39.8296ZM17.0953 12.3853C16.0747 12.3862 15.0962 12.792 14.3746 13.5137C13.6529 14.2353 13.2471 15.2138 13.2462 16.2344V33.7691C13.2471 34.7897 13.6529 35.7682 14.3746 36.4898C15.0962 37.2115 16.0747 37.6173 17.0953 37.6182H34.9047C35.9253 37.6173 36.9038 37.2115 37.6254 36.4898C38.3471 35.7682 38.7529 34.7897 38.7538 33.7691V16.2344C38.7529 15.2138 38.3471 14.2353 37.6254 13.5137C36.9038 12.792 35.9253 12.3862 34.9047 12.3853H17.0953Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0473 15.0556C34.7684 15.057 34.4961 15.141 34.2649 15.2969C34.0337 15.4529 33.8538 15.6738 33.748 15.9319C33.6422 16.1899 33.6153 16.4736 33.6705 16.7469C33.7258 17.0203 33.8608 17.2712 34.0585 17.4679C34.2562 17.6647 34.5077 17.7984 34.7814 17.8523C35.055 17.9063 35.3385 17.8779 35.596 17.7708C35.8536 17.6638 36.0737 17.4829 36.2285 17.2509C36.3833 17.0189 36.4659 16.7462 36.4659 16.4673C36.4659 16.2813 36.4292 16.0972 36.3578 15.9255C36.2864 15.7537 36.1818 15.5978 36.05 15.4666C35.9182 15.3354 35.7617 15.2316 35.5896 15.1611C35.4176 15.0905 35.2332 15.0547 35.0473 15.0556V15.0556Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 42.4012,
  y1: 43.87,
  x2: 9.59873,
  y2: 6.13351,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D3FD2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#B829A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#BF289D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#D0257E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E62256"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#E83156"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#EE5755"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#F89554"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC153"
})));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.9d2f215f.svg";
export { ForwardRef as ReactComponent };